/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDashboardSummaryResponse } from '../../models/user-dashboard-summary-response';

export interface GetUserDashboardSummary$Params {
}

export function getUserDashboardSummary(http: HttpClient, rootUrl: string, params?: GetUserDashboardSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDashboardSummaryResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserDashboardSummary.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDashboardSummaryResponse>;
    })
  );
}

getUserDashboardSummary.PATH = '/api/administration/dashboard/users/summary';
